var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.797,
    height: 32,
    viewBox: "0 0 36.797 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase_16_",
    "data-name": "briefcase (16)",
    transform: "translate(0 -32.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52739",
    "data-name": "Path 52739",
    d: "M33.126,38.808H25.2V35.615a2.761,2.761,0,0,0-2.758-2.757H14.352a2.761,2.761,0,0,0-2.758,2.757v3.193H3.669A3.666,3.666,0,0,0,.008,42.469c0,1.834-.188,3.481,1.2,5.333a5.96,5.96,0,0,0,3.125,2.162L16.549,53.52a6.6,6.6,0,0,0,3.7,0L32.46,49.964A5.961,5.961,0,0,0,35.585,47.8c1.4-1.86,1.2-3.524,1.2-5.333a3.665,3.665,0,0,0-3.661-3.661m-19.2-3.193a.422.422,0,0,1,.422-.422h8.091a.422.422,0,0,1,.422.422v3.193H13.93Z",
    transform: "translate(0 0)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52740",
    "data-name": "Path 52740",
    d: "M33.222,269.775c-13.175,3.836-13,3.914-14.716,3.914s-1.3-.006-14.716-3.913a8.271,8.271,0,0,1-3.674-2.218v11.208a3.665,3.665,0,0,0,3.661,3.661H33.235a3.665,3.665,0,0,0,3.661-3.661V267.557a8.271,8.271,0,0,1-3.674,2.218",
    transform: "translate(-0.109 -217.569)",
    fill: "#3db6fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.50a21fb79b99145fd5c1b13af553ad51.svg";
export { ForwardRef as ReactComponent };